import { resolveAeternaAssetPath } from "./assetBase";

const TOPOGRAPHY_TILE = 600;
const TOPOGRAPHY_URL = resolveAeternaAssetPath(
  "/assets/aeterna-invicta/patterns/topography.svg",
);

function hashSeed(value) {
  const text = String(value ?? "");
  let hash = 2166136261;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

function mulberry32(seed) {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let next = Math.imul(state ^ (state >>> 15), 1 | state);
    next ^= next + Math.imul(next ^ (next >>> 7), 61 | next);
    return ((next ^ (next >>> 14)) >>> 0) / 4294967296;
  };
}

function parseCreatedAtMs(createdAt) {
  if (typeof createdAt === "number" && Number.isFinite(createdAt)) {
    return createdAt;
  }
  if (typeof createdAt === "string" && createdAt.length) {
    const parsed = Date.parse(createdAt);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
}

export function getMatchTopographyStyle(match) {
  if (!match) return undefined;
  const createdAtMs = parseCreatedAtMs(match.createdAt);
  const seedSource =
    createdAtMs != null
      ? `topo:${createdAtMs}:${match.id || ""}`
      : `topo:${match.id || "default"}`;
  const rand = mulberry32(hashSeed(seedSource));
  const scale = 0.85 + rand() * 0.45;
  const tile = Math.round(TOPOGRAPHY_TILE * scale);
  const durationSec = 48 + Math.floor(rand() * 36);
  const flipX = rand() < 0.5 ? -1 : 1;
  const flipY = rand() < 0.5 ? -1 : 1;
  const dx = tile * flipX;
  const dy = tile * flipY;
  const startX = Math.floor(rand() * tile);
  const startY = Math.floor(rand() * tile);
  const durationMs = durationSec * 1000;
  const clockMs = createdAtMs != null ? createdAtMs : hashSeed(seedSource);
  const delayMs = -(((Date.now() - clockMs) % durationMs) + durationMs) % durationMs;

  return {
    "--ai-match-topo-image": `url("${TOPOGRAPHY_URL}")`,
    "--ai-match-topo-size": `${tile}px`,
    "--ai-match-topo-duration": `${durationSec}s`,
    "--ai-match-topo-delay": `${delayMs}ms`,
    "--ai-match-topo-start-x": `${startX}px`,
    "--ai-match-topo-start-y": `${startY}px`,
    "--ai-match-topo-end-x": `${startX + dx}px`,
    "--ai-match-topo-end-y": `${startY + dy}px`,
  };
}
